import styled from 'styled-components';
import PythonPlayground from '../../PythonPlayground';
import { Label, NonCopyableMarkdown, SectionWrapper } from '../common';
import { AssessmentTestContextType } from '../../../contexts/assessment-test';
import { AssessmentTestContext } from '../../../contexts/assessment-test';
import React from 'react';
import FollowUp from './FollowUp';

const PlaygroundWrapper = styled.div`
  height: 78vh;
  margin-top: 24px;
  padding-bottom: 12px;
  .py-playground-wrapper {
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.bgActive};
    background-color: ${({ theme }) => theme.colors.inputBackground};
    .ace_scrollbar {
      scrollbar-width: thin;
    }
  }

  .ace_content,
  .ace_edior .ace_scroller,
  .ace_scrollbar,
  .ace_text-input,
  .python-editor {
    overscroll-behavior: contain;
  }

  .py-playground-header {
    background-color: #161617;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .py-playground-controls {
    padding: 10px 20px;
    border-top: 1px solid ${({ theme }) => theme.colors.divider};
  }

  .ace_content {
    user-select: none;
  }
`;

export default function PythonEditorSection({
  stepId,
  section,
}: {
  section: Extract<
    AssessmentTestContextType['steps'][number]['sections'][number],
    { type: 'py-editor' }
  >;
  stepId: string;
}) {
  const { content, startingCode } = section;
  const code = section.answer;
  const [, dispatch] = React.useContext(AssessmentTestContext);

  const onCodeChange = (code: string) => {
    dispatch({
      type: 'CHANGE_ANSWER_PY_EDITOR',
      payload: { stepId, sectionId: section.id, answer: code },
    });
  };

  const onResetCode = () => {
    dispatch({
      type: 'CHANGE_ANSWER_PY_EDITOR',
      payload: {
        stepId,
        sectionId: section.id,
        answer: startingCode,
      },
    });
  };

  return (
    <SectionWrapper>
      <NonCopyableMarkdown md={content} />
      <PlaygroundWrapper>
        <PythonPlayground
          shouldDisalePaste
          headerText="Use the editor to answer"
          setupPy={startingCode}
          code={code}
          onCodeChange={onCodeChange}
          onResult={() => {}}
          onResetCode={onResetCode}
          isEditOnly
        />
      </PlaygroundWrapper>
      <Label>Write your answer in the code editor.</Label>
      <FollowUp section={section} stepId={stepId} />
    </SectionWrapper>
  );
}
